<template>
<transition name="el-fade-in">
    <div class="scroll"  v-show="isShow">
        <div class="el-icon-caret-top" id="toTop" @click="toTop(step)"></div>
    </div>
</transition>
</template>
<script>
let c;
let obj;
export default{
    props:{
        step:{   
            type:Number,
            default:50  
        }
    },
    data(){
        return {
            isShow:false,
        }
    },
    methods:{
        toTop(i){
            obj.scrollTop-=i;
            if (obj.scrollTop>0) {
                c=setTimeout(()=>this.toTop(i),16);
            }else {
                clearTimeout(c);
            }
        }
    },
    mounted(){
        let _this = this;
        obj = document.querySelector('#content .scrollView');
        obj.addEventListener('scroll',function(){
            if (obj.scrollTop>800) {
                _this.isShow=true;
            }else {
                _this.isShow=false;
            }
        },false);
    },
}
</script>
<style scoped lang="scss">
.scroll{
    background-color: #fff;
    position: fixed;
    right: 80px;
    bottom: 150px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    transition: .3s;
    box-shadow: 0 0 6px rgba(0,0,0,.12);
    z-index: 5;
    &:hover{
        box-shadow: 0 0 16px rgba(0,0,0,.12);
    }
}
.scroll>div{
    color: #1ab394;
    display: block;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
}

</style>